/**
 * The statements a signer confirms by ticking their signing box. Kept in a
 * leaf module (no React, no pdf.js) so both portal pages and their tests share
 * one copy.
 */

/** What every signer except the plan member confirms. */
export const DEFAULT_CONFIRM_STATEMENT =
  "I confirm the information on this form is accurate and this typed signature represents my legal signature.";

/**
 * What the plan member confirms when they sign. Their link carries no identity
 * challenge (Michael, 2026-10-08, case imp_56299acf): the single-use link to
 * their own inbox is the check, and this statement — the label of their signing
 * checkbox, submitted verbatim as `attestation.text` — is their word that they
 * are the person signing AND that their section is right (imp_93b41233: "the
 * plan member is agreeing all things on the form they filled out are right").
 * One tick, after they have seen their information. Do not reword without
 * updating the case.
 */
export const PLAN_MEMBER_ATTESTATION_TEXT =
  "I am the plan member named on this form. The information in the plan member section is correct, and this typed signature is my legal signature.";
